var global = require('../internals/global');

module.exports = global;



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/path.js